<template>
  <div>
    <!-- <div v-if="facet.facetValue.data" class="filter-title">{{ facet.facetValue. name }}</div> -->
    <div v-if="values.data" class="filter-title">{{ values.name }}</div>
    <vue-slider
      class="px-2"
      :min="facet.min ? facet.min : 0"
      :max="facet.max ? facet.max : 99"
      :lazy="true"
      :value="[smallerValue, biggerValue]"
      @change="refine({ min: $event[0], max: $event[1] })"
    />
    <!-- <vue-slider class="px-2" :min="facet.min ? facet.min : 0" :max="facet.max ? facet.max : 99" :lazy="true" :value="[smallerValue, biggerValue]" /> -->
    <!-- :value="toValue(currentRefinement, range)"    @change="refine({ min: $event[0], max: $event[1] })" -->
  </div>
</template>

<script setup>
import { ref } from 'vue';

import VueSlider from 'vue-slider-component';
import 'vue-slider-component/theme/default.css';

// eslint-disable-next-line no-undef
const props = defineProps({
  facet: {
    type: Object,
    required: true
  },
  values: {
    type: Object,
    required: true
  },
  rangeChange: {
    type: Function,
    required: true
  },
  selectedMin: {
    type: Number,
    default: null
  },
  selectedMax: {
    type: Number,
    default: null
  }
});

const smallerValue = ref(props.selectedMin ? props.selectedMin : Math.min(...props.values.data.map(f => f.value)));

const biggerValue = ref(props.selectedMax ? props.selectedMax : Math.max(...props.values.data.map(f => f.value)));

const refine = values => {
  props.rangeChange(props.facet.attribute, values);
};

</script>
